module.exports = __webpack_public_path__ + "img/bg_header_sp.d30453e2.png";